import Header from "../components/header";
import Form from "../components/form";
import LeftAlignedText from "../components/left-aligned-text";
import TwoGrid from "../components/two-grid";

function SignUpPage(){
    const sendToLogin = () => {
        window.location.href = '/login';
    }
    return <>
    <Header URLForLogo='/' CTA='Log in' functionForButton={sendToLogin}></Header>
    <TwoGrid item2={<Form></Form>} item1={<LeftAlignedText heading='Start your journey with Mako' text='Mako crawls your inputs, alerts you to new posts and helps you create limitless content ideas with one click. '></LeftAlignedText>}></TwoGrid>
   
    </>
}
    
export default SignUpPage;